import PokiLogo from "../assets/image/poki-logo.webp";
import BlacknutLogo from "../assets/image/blacknut-logo.webp";
import CALogo from "../assets/feature/challenge-arena/challenge-arena.webp";

import PokiIcon from "../assets/feature/poki/poki_1x.webp";
import PokiIcon2x from "../assets/feature/poki/poki_2x.webp";
import PokiIcon3x from "../assets/feature/poki/poki_3x.webp";
import BlacknutIcon from "../assets/feature/blacknut/blacknut_1x.webp";
import BlacknutIcon2x from "../assets/feature/blacknut/blacknut_2x.webp";
import BlacknutIcon3x from "../assets/feature/blacknut/blacknut_3x.webp";
import OnmoIcon from "../assets/feature/onmo/onmo_1x.webp";
import OnmoIcon2x from "../assets/feature/onmo/onmo_2x.webp";
import OnmoIcon3x from "../assets/feature/onmo/onmo_3x.webp";
import ArenaIcon from "../assets/feature/challenge-arena/arena_1x.webp";
import ArenaIcon2x from "../assets/feature/challenge-arena/arena_2x.webp";
import ArenaIcon3x from "../assets/feature/challenge-arena/arena_3x.webp";
import VideoLogo from "../assets/feature/videos/video-logo_1x.webp";
import VideoLogo2x from "../assets/feature/videos/video-logo_2x.webp";
import VideoLogo3x from "../assets/feature/videos/video-logo_3x.webp";
import NewsLogo from "../assets/feature/news/news-logo_1x.webp";
import NewsLogo2x from "../assets/feature/news/news-logo_2x.webp";
import NewsLogo3x from "../assets/feature/news/news-logo_3x.webp";
import ESportsLogo from "../assets/feature/esports/eSports-logo_1x.webp";
import ESportsLogo2x from "../assets/feature/esports/eSports-logo_2x.webp";
import ESportsLogo3x from "../assets/feature/esports/eSports-logo_3x.webp";
import VouchersLogo from "../assets/feature/vouchers/vouchers-logo_1x.webp";
import VouchersLogo2x from "../assets/feature/vouchers/vouchers-logo_2x.webp";
import VouchersLogo3x from "../assets/feature/vouchers/vouchers-logo_3x.webp";
import { find, map } from "lodash-es";
import { IServiceDataItem } from "../components/common/FeatureSlider/FeatureSlider";
import { AllInteractions } from "../models/homepage";

export const defaultServiceIcon = [
  {
    title: "Featured",
  },
  {
    title: "Challenge Arena",
    logo: CALogo,
    icon: {
      src1x: ArenaIcon,
      src2x: ArenaIcon2x,
      src3x: ArenaIcon3x,
    },
    id: "ca",
  },
  {
    title: "Onmo",
    logo: "/onmo-logo.webp",
    icon: {
      src1x: OnmoIcon,
      src2x: OnmoIcon2x,
      src3x: OnmoIcon3x,
    },
    id: "onmo",
  },
  {
    title: "Blacknut",
    logo: BlacknutLogo,
    icon: {
      src1x: BlacknutIcon,
      src2x: BlacknutIcon2x,
      src3x: BlacknutIcon3x,
    },
    id: "blacknut",
  },
  {
    title: "Poki",
    logo: PokiLogo,
    icon: {
      src1x: PokiIcon,
      src2x: PokiIcon2x,
      src3x: PokiIcon3x,
    },
    id: "poki",
  },
  {
    title: "Video",
    icon: {
      src1x: VideoLogo,
      src2x: VideoLogo2x,
      src3x: VideoLogo3x,
    },
    id: "video",
  },
  {
    title: "News",
    icon: {
      src1x: NewsLogo,
      src2x: NewsLogo2x,
      src3x: NewsLogo3x,
    },
    id: "news",
  },
  {
    title: "Esports",
    icon: {
      src1x: ESportsLogo,
      src2x: ESportsLogo2x,
      src3x: ESportsLogo3x,
    },
    id: "esports",
  },
  {
    title: "Vouchers",
    icon: {
      src1x: VouchersLogo,
      src2x: VouchersLogo2x,
      src3x: VouchersLogo3x,
    },
    id: "vouchers",
  },
];

export const defaultServicesList = [
  {
    title: "Featured",
    itemType: "feature",
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/GameFest/GameFest.png",
        link: "https://tournaments.onmobile.com/onmo/dialog-gfv3/gamefest/",
      },
      {
        title: "God of War",
        description:
          "Join Kratos and Atreus to explore the mythic Nine Realms in search of answers and allies",

        image:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/GOW/GOW-BG.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/GOW/Video/GOW.mp4",
      },
      {
        title: "ONMO Cloud",
        description: "Bangladesh’s First Ever Cloud Gaming Platform",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/ONMO-UGC/ONMO-BG.png",
        link: "https://play.onmo.com/",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/ONMO-UGC/ONMO-Video.mp4",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Featured/GoogleAd/NoHeader/InterstitialAd.png",
        hideButton: true,
      },
    ],
  },
  {
    title: "Challenge Arena",
    itemType: "square",
    description: "Challenge Yourself in Challenges Arena!",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/CA/CA-BG.png",
    primaryColor: "#EE2737",
    enterLink: "https://vistg.wineazy.com/cavilstg",
    disableIframe: true,
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Fruit-Merge.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Videos/Fruit-Merge.mp4",
        link: "https://vistg.wineazy.com/cavilstg/play/GAMETEMPLATE/5409090802664538112/5409100541855203328",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Solitaire.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Videos/Solitaire.mp4",
        link: "https://vistg.wineazy.com/cavilstg/play/GAMETOURNAMENT/5148692/5441253987618062336",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Color-Sort.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Videos/Color-Sort.mp4",
        link: "https://vistg.wineazy.com/cavilstg/play/GAMETOURNAMENT/4954867/5410065586311331840",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Archery.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Videos/Archery.mp4",
        link: "https://vistg.wineazy.com/cavilstg/play/GAMETOURNAMENT/5097368/5427821436345974784",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Cricket.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/CA/Videos/Cricket.mp4",
        link: "https://vistg.wineazy.com/cavilstg/play/GAMETOURNAMENT/5094681/5426142598826229760",
        disableIframe: true,
      },
    ],
  },
  {
    title: "Onmo",
    itemType: "vertical",
    enterLink: "https://play.onmo.com",
    logo: "/onmo-logo.webp",
    description: "Instant Game Store",
    primaryColor: "#C486F8",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/ONMO/ONMO-BG.png",
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Subway-Surfers.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/Subway-Surfers.mp4",
        link: "https://play.onmo.com/play/challenge/152144?momentId=46f12cfd-7136-4c28-be0f-5d5fa18a9848",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Cut-The-Rope-Magic.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/Cut-The-Rope.mp4",
        link: "https://play.onmo.com/play/challenge/141753?momentId=889bba61-7e1b-4feb-83a1-4f8854cc9d73",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Hitman-Sniper.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/Hitman-Sniper.mp4",
        link: "https://play.onmo.com/play/challenge/13497?momentId=304627bf-0c72-40cb-9100-323c4222d6eb",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Lara-Croft-Relic-Run.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/LaraCroft-RelicRun.mp4",
        link: "https://play.onmo.com/play/challenge/13393?momentId=8ca4a8f1-d16a-400a-9752-6f60b99c1344",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Gravity-Rider.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/Gravity-Raider.mp4",
        link: "https://play.onmo.com/play/challenge/13454?momentId=7d2d2661-19a0-4ab4-a6d3-4f86134d2fbe",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Run-and-Gun-Banditos.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/ONMO/Videos/Run-Gun-Bandoits.mp4",
        link: "https://play.onmo.com/play/challenge/13515?momentId=baf4dcff-46eb-45cc-8ebb-7ae2d2d29ab3",
      },
    ],
  },
  {
    title: "Blacknut",
    itemType: "square",
    enterLink: "https://app.blacknut.com/catalog",
    description: "Turn your screen into a game console",
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Blacknut.png",
    disableIframe: true,
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Assassins-Creed.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Videos/Assasins-Creed-Freedom-Cry.mp4",
        link: "https://app.blacknut.com/game/664cb05bdda24002c0629216",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Rayman.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Videos/Rayman-Legands.mp4",
        link: "https://app.blacknut.com/game/662a0aa3dda2404240585bfe",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Indiana-Jones.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Videos/Lego-Indian-Jones.mp4",
        link: "https://app.blacknut.com/game/5f16e61bdda24019c043b33d",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Asphalt.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Videos/Asphalt-9.mp4",
        link: "https://app.blacknut.com/game/5f16e61bdda24019c043b33d",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Far-Cry.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Blacknut/Videos/Far-Cry.mp4",
        link: "https://app.blacknut.com/game/61264650dda2400d230675e1",
        disableIframe: true,
      },
    ],
  },
  {
    title: "Poki",
    itemType: "square",
    enterLink: "https://poki.com/",
    description: "Enjoy Unlimited Gaming with Poki !",
    primaryColor: "#0C5154",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Poki/Poki-BG.png",
    disableIframe: true,
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Drive-Mad.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Videos/Drive-Mad.mp4",
        link: "https://poki.com/en/g/drive-mad",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Vectaria.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Videos/Vectaria.mp4",
        link: "https://poki.com/en/g/vectaria-io",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Mr-Racer.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Videos/Mr-Racer.mp4",
        link: "https://poki.com/en/g/mr-racer-car-racing",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Monkey-Mart.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Videos/Monkey-Mart.mp4",
        link: "https://poki.com/en/g/monkey-mart",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Stickman-Hook.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Poki/Videos/Stickman-Hook.mp4",
        link: "https://poki.com/en/g/stickman-hook",
        disableIframe: true,
      },
    ],
  },
  {
    title: "Video",
    itemType: "vertical",
    disableRadius: true,
    description: "Check out videos on trending and top games",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/video-page/video-bg.jpg",
    display: "tab",
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title1.png",
        link: "https://www.youtube.com/channel/UCD-6YWTBwjRFHKBDNpbQgyQ/live",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title2.png",
        link: "https://www.twitch.tv/directory/category/league-of-legends",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title3.png",
        link: "https://www.twitch.tv/directory/category/marvel-rivals",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title4.png",
        link: "https://www.youtube.com/channel/UCiMRGE8Sc6oxIGuu_JxFoHg/live",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title5.png",
        link: "https://www.twitch.tv/directory/category/path-of-exile-2",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/video-title6.png",
        link: "https://www.twitch.tv/directory/category/fortnite",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title7.png",
        link: "https://www.youtube.com/channel/UCOquqcRMJmURiGfEnaitptg/live",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/video-page/esports-title8.png",
        link: "https://www.twitch.tv/directory/category/world-of-warcraft",
        disableIframe: true,
      },
    ],
  },
  {
    title: "News",
    itemType: "square",
    description: "Get live updates of all gaming news here",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/news-page/news-bg.jpg",
    sliderItems: [
      {
        name: "Games",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/news-page/icon-news-games.png",
        link: "https://www.gamespot.com/games/",
      },
      {
        name: "Tech",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/news-page/icon-news-tech.png",
        link: "https://in.ign.com/tech",
        disableIframe: true,
      },
      {
        name: "Entertainment",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/news-page/icon-news-entertainment.png",
        link: "https://www.polygon.com/entertainment",
        disableIframe: true,
      },
      {
        name: "Reviews",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/news-page/icon-news-reviews.png",
        link: "https://www.gamespot.com/games/reviews/",
      },
      {
        name: "Sports",
        image:
          "https://assets.onmostealth.com/static/gaming-platform/news-page/icon-news-sports.png",
        link: "https://in.ign.com/esports",
        disableIframe: true,
      },
    ],
  },
  {
    title: "Esports",
    itemType: "square",
    description: "Elevate Your eSports Experience!",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/esports-page/esports-bg.jpg",
    primaryColor: "#19B1D9",
    enterLink: "https://challengesarena.com/BTdemo/home",
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/esports-page/esports-title1.png",
        link: "https://challengesarena.com/BTdemo/home/tournaments/3480230",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/esports-page/esports-title2.png",
        link: "https://challengesarena.com/BTdemo/home/tournaments/3480216",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/esports-page/esports-title3.png",
        link: "https://challengesarena.com/BTdemo/home/tournaments/3480237",
      },
    ],
  },
  {
    title: "Vouchers",
    itemType: "horizontal",
    description: "Great deals on shopping and restaurants",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/voucher-page/voucher-bg.jpg",
    primaryColor: "#19B1D9",
    enterLink: "https://stores.xoxoday.com/marketplace/home",
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/voucher-page/levis.webp",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/voucher-page/jewellery.webp",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/voucher-page/janishq.webp",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/voucher-page/baskin-robbins.webp",
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/voucher-page/joyalukkas.webp",
      },
    ],
  },
];

const dataFeatureHomePage =
  JSON.parse(import.meta.env.VITE_FEATURED_HOMEPAGE_CFG || "null") ||
  defaultServicesList;

export const servicesList = map(defaultServiceIcon, (serviceIcon) => {
  const serviceItem = find(dataFeatureHomePage, {
    title: serviceIcon.title,
  }) as IServiceDataItem;

  if (serviceItem.itemType === "feature" && serviceItem.sliderItems?.length) {
    function pushItemEveryThree<T>(array: T[], item: T): T[] {
      const result: T[] = [];
      for (let i = 0; i < array.length; i++) {
        result.push(array[i]);
        if ((i + 1) % 3 === 0) {
          result.push(item);
        }
      }
      return result;
    }

    const newSliderItems = pushItemEveryThree(serviceItem.sliderItems, {
      title: "Google Ads",
      hideButton: true,
      image: "",
    });
    return {
      ...serviceIcon,
      ...serviceItem,
      sliderItems: newSliderItems,
    };
  }

  return {
    ...serviceIcon,
    ...serviceItem,
  };
});

export const MOCK_SERVICE_INTERACTIONS: Readonly<AllInteractions> = {
  "Challenge Arena": { isFavorited: false, dateFavorited: null },
  Onmo: { isFavorited: false, dateFavorited: null },
  Blacknut: { isFavorited: false, dateFavorited: null },
  Poki: { isFavorited: false, dateFavorited: null },
  Video: { isFavorited: false, dateFavorited: null },
  News: { isFavorited: false, dateFavorited: null },
  Esports: { isFavorited: false, dateFavorited: null },
  Vouchers: { isFavorited: false, dateFavorited: null },
};
